<section class="news-media-content" [attr.aria-busy]="state === 'loading'">
  <app-loader [loading]="state === 'loading'"></app-loader>

  <p class="news-media-content__message" *ngIf="state === 'error'" role="alert">
    {{ 'NEWS-MEDIA_ERROR' | translate }}
  </p>

  <p class="news-media-content__message" *ngIf="state === 'empty'">
    {{ 'NEWS-MEDIA_EMPTY' | translate }}
  </p>

  <div
    class="news-media-content__wordpress"
    [class.news-media-content__wordpress--list]="isListContent"
    *ngIf="state === 'content'"
    [innerHTML]="content"
    (click)="onWordpressClick($event)"
  ></div>
</section>
